import { render } from "./invoicePaymentsList.vue?vue&type=template&id=10e32126&scoped=true"
import script from "./invoicePaymentsList.vue?vue&type=script&lang=js"
export * from "./invoicePaymentsList.vue?vue&type=script&lang=js"

import "./invoicePaymentsList.vue?vue&type=style&index=0&id=10e32126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e32126"]])

export default __exports__